export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/thumbnail-tatty-teddy-2d8adf597405bcc981d0f16ac741c5c4.png";